import { BaseService } from 'core/services';
import ReferralRouteService from './ReferralRouteService';

class ReferralService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ReferralRouteService());
    }

    async invalidate(){
        const url = this.routeService.invalidate();
        const response = await this.apiClient.delete(url);
        return response.data || null;
    }

}

export default ReferralService;